import { useMemo } from 'react';
import { useToast } from '@/components/ui';

/**
 * Kleine Huelle um den Toast des Design-Systems, damit Seiten
 * `notify.success(...)` statt `show(..., 'success')` schreiben koennen.
 */
export function useNotify() {
  const { show } = useToast();

  return useMemo(
    () => ({
      success: (message: string) => show(message, 'success'),
      error: (message: string) => show(message, 'danger'),
      info: (message: string) => show(message, 'info'),
      warn: (message: string) => show(message, 'warning'),
      /** Nimmt einen unbekannten Fehler entgegen und zeigt eine lesbare Meldung. */
      fromError: (cause: unknown, fallback = 'Aktion fehlgeschlagen') =>
        show(cause instanceof Error ? cause.message : fallback, 'danger'),
    }),
    [show],
  );
}
